import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axiosClient from '../api/axiosClient';
import { config } from '../Common/Constants';
const URL = config.url;

export const fetchStories = createAsyncThunk(
  'stories/fetchStories',
  async (_, { getState, rejectWithValue }) => {
    const userId = getState().user?.user?.uid ?? null;
    const endpoint = userId
      ? `${URL}/KahaniJson/getkahanis/${userId}`
      : `${URL}/KahaniJson/kahanis`;
    try {
      const response = await axiosClient.get(endpoint);
      console.log('response', response.data);
      // Expecting response.data = Array of story objects, each with a `slug` field
      return response.data;
      
    } catch (err) {
      // Return a clean error message
      return rejectWithValue(
        err.response?.data?.message || err.message || 'Failed to fetch stories'
      );
    }
  }
);

const storiesSlice = createSlice({
  name: 'stories',
  initialState: {
    stories: [],
    status: 'idle',    // 'idle' | 'loading' | 'succeeded' | 'failed'
    error: null,
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchStories.pending, state => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchStories.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.stories = action.payload;
      })
      .addCase(fetchStories.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || action.error.message;
      });
  },
});

export default storiesSlice.reducer;
